module.exports = __webpack_public_path__ + "img/foley-bus-lines.6c987ac8.png";